export default class TableWidgetCellStyle {
    constructor() {
        this.row_span = 1
        this.col_span = 1
        this.border_side = null
        this.background_color = ''
        this.font_size = 14
        this.font_color = '#000'
        this.alignment = 'center'
        this.direction = ''
        this.margin_left = 0
        this.margin_right = 0
        this.width = 'auto'
        this.height = 0.5
        this.text_placement = 'below'
        this.image_placement = 'left'
    }
}
